import React from 'react';
import PageContainerAuth from '../../components/common/PageContainerAuth';
import TemplateCreateSection from '../../components/pages/templates/create/TemplateCreateSection';

export default function TemplateCreate() {
    return (
        <PageContainerAuth section="mailings-templates-add" pageTitle="Nouveau Template email">
            <TemplateCreateSection/>
        </PageContainerAuth>
    );
}